const allowedProtocols = ["http:", "https:"];

export function sanitizeRedirectUrl(
  url: string | null,
  fallback: string = ""
): string {
  if (!url || typeof url !== "string" || !url.trim()) return fallback;
  try {
    const parsed = new URL(url, window.location.origin);

    // block e.g. javascript:…
    if (!allowedProtocols.includes(parsed.protocol)) {
      return fallback;
    }

    if (parsed.origin !== window.location.origin) {
      return fallback;
    }

    const relativeURL = parsed.pathname + parsed.search;

    // check if there is an absolute URL in pathname or search by parsing again
    if (
      new URL(relativeURL, window.location.origin).origin !==
      window.location.origin
    ) {
      return fallback;
    }

    // Block malformed input that results in a pathname like "/://" or similar
    if (parsed.pathname === "/://") return fallback;
    if (relativeURL.startsWith("//")) return fallback;
    if (/[a-z][a-z0-9+.-]*:\/\//i.test(relativeURL)) return fallback;
    // Prevent redirect loops to login/password-reset pages
    if (/^\/(login|password-reset|set-password)(\/|$)/.test(parsed.pathname))
      return fallback;
    return relativeURL;
  } catch {
    return fallback;
  }
}
